import {
  ACTION_TEST_POSTBACK_SETTINGS__REQUEST,
  ACTION_TEST_POSTBACK_SETTINGS__SUCCESS,
  ACTION_TEST_POSTBACK_SETTINGS__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_TEST_POSTBACK_SETTINGS__REQUEST:
    case ACTION_TEST_POSTBACK_SETTINGS__SUCCESS:
      return null;

    case ACTION_TEST_POSTBACK_SETTINGS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
